import * as React from 'react'
import { AntdIconProps } from '@ant-design/icons/es/components/AntdIcon'
import Icon from '@ant-design/icons'

const ChevronDownSvg = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='2 4 24 10'
      height='1em'
      width='1em'
    >
      <path
        d='M14.02 15.75c-.39 0-.78-.15-1.07-.44L4.62 6.98c-.59-.59-.59-1.55 0-2.15.59-.59 1.55-.59 2.15 0l7.26 7.26 7.2-7.07c.6-.59 1.56-.58 2.15.02.59.6.58 1.56-.02 2.15l-8.28 8.12c-.29.3-.67.44-1.06.44z'
        fill='#bac5d4'
      />
    </svg>
  )
}

export const ChevronDownIcon = (props: AntdIconProps) => (
  <Icon component={ChevronDownSvg} {...(props as any)} />
)
